import Vue from "vue"
import Vuex from "vuex"
import documentResult from "./modules/DocumentResult"
import {
  AUTHENTICATE_STORE,
  AuthenticateStore,
} from "@/store/modules/AuthenticateStore.js"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    docRes: documentResult,
    [AUTHENTICATE_STORE]: AuthenticateStore,
  },
})
